import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '专题推荐', href: '#carousel' },
  { label: '关于我们', href: '#about' },
  { label: '精选推荐', href: '#cards' },
  { label: '热播榜单', href: '#ranking' },
  { label: '常见问题', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-[68px] px-4 md:px-6 max-w-[1400px] mx-auto">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 no-underline"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-movie-2-fill text-background-50 text-lg"></i>
          </span>
          <span className="text-xl font-heading font-bold text-foreground-950 whitespace-nowrap">
            春色影视
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                item.label === '首页'
                  ? 'text-primary-600 hover:text-primary-700 hover:bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50 border-b border-background-200/60 px-4 pb-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className={`block px-3 py-3 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                item.label === '首页'
                  ? 'text-primary-600 hover:bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}